import { render, staticRenderFns } from "./AvatarCategoriesPage.vue?vue&type=template&id=68eb069f&"
import script from "./AvatarCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./AvatarCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports